<script>
  import {SERVICES} from '@/const/services';
  import {IMAGE_EXTRA} from '../images';

  let index = null;
  let isHover = false;
  const images = ['TWITTER', 'BLOOMBERG', 'NASDAQ', 'COIN_GECKO', 'COIN_MARKET_CAP', 'TRADING_VIEW', 'SIMPLEX', 'CHAINALYSIS', 'JUMIO', 'MOONPAY', 'SOURCE'];

  function handleMouseenter(idx) {
    index = idx;
    isHover = true;
  }

  function handleMouseleave() {
    index = null;
    isHover = false;
  }
</script>

<style>
  .wrap {
    margin-top: 60px;
    padding: 80px 0;
    height: auto;
    overflow: hidden;
  }
  .scroller {
    animation: move 10s linear infinite;
  }
  .scroller:hover {
    animation-play-state: paused;
  }
  .gap-106 {
    gap: 106px;
  }
  img {
    height: 38px !important;
  }
  img:first-child {
    margin-left: 0;
  }
  .image {
    transition: all 0.3s ease-in-out;
  }
  .show-color > img.image-color,
  .show-white > img.image-white{
    visibility: visible;
    height: auto;
    display: block;
  }
  .show-color > img.image-white,
  .show-white > img.image-color{
    visibility: hidden;
    height: 0;
    display: none;
  }
  @keyframes move {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(calc(-50% + 40px), 0);
    }
  }
  @media screen and (max-width: 640px) {
    .wrap {
      margin-top: 40px;
      padding: 24px 0;
    }
    .scroller {
      gap: 40px;
    }
    .scroller img {
      height: 24px !important;
    }
  }
</style>

<section class="wrap over">
  <div class="scroller df gap-106">
    {#each [...images, ...images] as img, idx}
      <div class={isHover && index === idx && !!IMAGE_EXTRA[img + '_COLOR'] ? 'show-color' : 'show-white'} on:mouseenter={handleMouseenter.bind(null, idx)} on:mouseleave={handleMouseleave}>
          <img class="usn image image-color" src={`${SERVICES.IMG_URL}/v1/${IMAGE_EXTRA[img + '_COLOR']}`} alt={img} />
          <img class="usn image image-white" src={`${SERVICES.IMG_URL}/v1/${IMAGE_EXTRA[img]}`} alt={img} />
      </div>
    {/each}
  </div>
</section>
